export default __webpack_public_path__ + "static/media/img12.8d710c14.png";